'use strict';

import { processInclude } from './util/common';

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./wishlist/wishlist'));
});
